<script lang="ts" setup>
import { paginationLeftButton, paginationRightButton } from "~/utils/styles";

const { searchState, pagination } = useCustomContentSearch({ initialize: false });
</script>

<template>
  <UPagination v-model:page="searchState.page" :items-per-page="pagination.pageSize" :total="pagination.totalItems">
    <template #prev>
      <UButton icon="i-ph-arrow-circle-left" :class="paginationLeftButton" />
    </template>

    <template #next>
      <UButton icon="i-ph-arrow-circle-right" :class="paginationRightButton" />
    </template>
  </UPagination>
</template>

<style scoped>

</style>
